import dayjs from "dayjs";

// Month/Year filters for Digital Delivery. `item.date` comes from the API as an
// ISO timestamp (older mock data used "M/D/YYYY"), and the list shows it via
// formatDate(date, "M/DD/YYYY") in local time, so read it the same way here.
export function deliveryDateParts(value) {
  if (!value) return null;
  const date = dayjs(value);
  if (!date.isValid()) return null;
  return { month: date.format("MM"), year: date.format("YYYY") };
}

export function matchesDeliveryDateFilters(item, filters = {}) {
  const years = Array.isArray(filters.Year) ? filters.Year : [];
  const months = Array.isArray(filters.Month) ? filters.Month : [];
  if (!years.length && !months.length) return true;

  const parts = deliveryDateParts(item?.date);
  if (!parts) return true;
  if (years.length && !years.includes(parts.year)) return false;
  if (months.length && !months.includes(parts.month)) return false;
  return true;
}

export function deliveryYearOptions(items, now = new Date()) {
  // The current year is always offered so recent deliveries can be filtered.
  const years = new Set([String(dayjs(now).year())]);
  for (const item of Array.isArray(items) ? items : []) {
    const parts = deliveryDateParts(item?.date);
    if (parts) years.add(parts.year);
  }
  return Array.from(years)
    .sort((a, b) => b.localeCompare(a))
    .map((year) => ({ label: year, value: year }));
}
